import React from 'react';
import Card from '@mui/material/Card';
import { DashboardIcon, DashboardIconType } from './DashboardIcon';

type FleetMetricCardProps = {
  className?: string;
  delta?: string;
  icon: DashboardIconType;
  label: string;
  tone: string;
  value: string;
};

export function FleetMetricCard({
  className = '',
  delta,
  icon,
  label,
  tone,
  value,
}: FleetMetricCardProps) {
  const isDown = delta?.startsWith('-') ?? false;

  return (
    <Card className={`fleet-stat-card${className ? ` ${className}` : ''}`} component="article">
      <div className="fleet-stat-top">
        <span className={`fleet-icon ${tone}`}>
          <DashboardIcon type={icon} size={24} />
        </span>
        {delta ? (
          <span className={`fleet-delta ${isDown ? 'down' : 'up'}`}>
            <DashboardIcon type={isDown ? 'trend-down' : 'trend-up'} size={24} />
            {delta}
          </span>
        ) : null}
      </div>
      <strong>{value}</strong>
      <span>{label}</span>
    </Card>
  );
}
